import { render, staticRenderFns } from "./LivingSituationEditor.vue?vue&type=template&id=851f083a&scoped=true&"
import script from "./LivingSituationEditor.vue?vue&type=script&lang=js&"
export * from "./LivingSituationEditor.vue?vue&type=script&lang=js&"
import style0 from "./LivingSituationEditor.vue?vue&type=style&index=0&id=851f083a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851f083a",
  null
  
)

export default component.exports